
import { Injector, NgModule, CUSTOM_ELEMENTS_SCHEMA, importProvidersFrom } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ProgramComponent } from './components/program/program.component';
import { AuthGuard } from './services/auth.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SignupSuccessComponent } from './components/signup-success/signup-success.component';
import { StoranConstant } from '../app/storan-constant';
import { UserService } from './services/user.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import OktaSignIn from '@okta/okta-signin-widget';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { FormsModule } from '@angular/forms';
import { SignupuserService } from './services/signupuser.service';
import { provideHttpClient } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { SignupComponent } from './components/signup/signup.component';
import { ErrorComponent } from './components/error/error.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { RedirectExternalComponent } from './components/Redirect/RedirectExternalComponent';

localStorage.setItem('oktaConfig', JSON.stringify(StoranConstant.getEnvironmentVariable()));

let authConfig = JSON.parse(JSON.stringify(StoranConstant.getEnvironmentVariable()));
const oktaAuth = new OktaAuth(authConfig);
@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    LoginComponent,
    SignupComponent,
    SignupSuccessComponent,
    ErrorComponent,
    WelcomeComponent,
    RedirectExternalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    OktaAuthModule,
    NgxSpinnerModule,
    DialogModule
  ],
  providers: [
    UserService,
    AuthGuard,
    SignupuserService,importProvidersFrom(BrowserAnimationsModule),
    provideHttpClient(),
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },
    Title,
    NgxSpinnerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
function OAuthSettings(this: any, key: string, value: any) {
  throw new Error('Function not implemented.');
}

